module.exports = __webpack_public_path__ + "img/3_111.ecf0aa6d.png";